import React from 'react';
import { ExtendedTheme, Skeletons } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/core';
import { filterClassesForUndefinedValue } from '../../../utils/utils';
import { InsightsSkeletonProps } from './SkeletonUtils';

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) => createStyles({
	avatar: {
		width: `${theme.spacing(8)}px !important`,
		height: `${theme.spacing(8)}px !important`,
		borderRadius: '50%'
	},
	largeTitle: {
		width: `${theme.spacing(20)}px !important`,
		height: `${theme.spacing(6)}px !important`,
		borderRadius: theme.spacing(6)
	},
	title1: {
		width: `${theme.spacing(20)}px !important`,
		height: `${theme.spacing(4)}px !important`,
		borderRadius: theme.spacing(4)
	},
	subTitle: {
		width: `${theme.spacing(40)}px !important`,
		height: `${theme.spacing(2.5)}px !important`,
		borderRadius: theme.spacing(2.5)
	},
	default: {
		width: `${theme.spacing(8)}px !important`,
		height: `${theme.spacing(1)}px !important`,
		borderRadius: theme.spacing(1)
	},
	base: {
		'--animation-duration': 'none !important'
	}
}));

export const Skeleton = (props: InsightsSkeletonProps) => {
	const classes = useStyles();

	const { type, className, dataLoaded, children } = props;

	const getSkeletonClassNameByType = () => {
		if (type === 'avatar') {
			return classes.avatar;
		}

		if (type === 'largeTitle') {
			return classes.largeTitle;
		}

		if (type === 'title1') {
			return classes.title1;
		}

		if (type === 'subTitle') {
			return classes.subTitle;
		}

		return classes.default;
	}

	return (
		<Skeletons
			count={1}
			dataLoaded={dataLoaded}
			className={filterClassesForUndefinedValue([getSkeletonClassNameByType(), className, classes.base])}
			children={children}
		/>
	);
};

export default Skeleton;
